module.exports = __webpack_public_path__ + "img/ISO27018.5677833f.jpg";